<template>
  <v-card class="mt-5">
    <v-toolbar color="white" flat>
      <v-toolbar-title>Author Team</v-toolbar-title>
      <v-spacer />
      <v-dialog v-model="newDialog" max-width="500px">
        <v-btn slot="activator" color="secondary" dark class="mb-2" icon round>
          <v-icon>add</v-icon>
        </v-btn>
        <form @submit.prevent="saveNewAuthor">
          <v-card>
            <v-card-title>
              <span class="headline">New Author Team User</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-autocomplete
                      v-model="newAuthorObject"
                      v-validate="'required'"
                      :items="authors"
                      label="Author"
                      name="author"
                      box
                      clearable
                      cache-items
                      return-object
                      item-text="fullName"
                      placeholder="Start typing to Search"
                      :search-input.sync="search"
                      :loading="loadingAutocomplete"
                    >
                      <template v-slot:selection="data">
                        {{ data.item.fullName }} ({{ data.item.email }})
                      </template>
                      <template v-slot:item="data">
                        <v-list-tile-avatar>
                          <img :src="data.item.profileImageUrl">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="data.item.fullName" />
                          <v-list-tile-sub-title v-html="data.item.email" />
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" flat @click.native="closeNewModal">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" flat type="submit" :loading="savingNewAuthor">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-dialog>
    </v-toolbar>
    <v-data-table flat :headers="[{ text: 'Author', value: 'fullName', align: 'left' },{align: 'right', sortable: false,}]" :items="authorTeamUsers" :loading="fetchingAuthorTeam">
      <template v-slot:items="props">
        <td>{{ props.item.fullName }}</td>
        <td class="text-xs-right">
          <v-icon @click="deleteAuthor(props.item)">
            far fa-trash-alt
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import axios from 'axios';
  import _ from 'lodash';

  export default {
    props: ['value', 'courseId'],
    data() {
      return {
        loadingAutocomplete: [],
        authors: [],
        authorTeamUsers: [],
        newDialog: false,
        savingNewAuthor: false,
        fetchingAuthorTeam: false,
        search: null,
        newAuthorObject: null,
      };
    },

    watch: {
      search(val) {
        this.loadingAutocomplete = true;
        this.processSearch();
      },
    },

    mounted() {
      this.getAuthorTeam();
    },

    methods: {
      async getUsers() {
        const { data } = await axios.get(`/api/users/dropdown?filter=${this.search}&currentPage=0&pageSize=20`);
        this.authors = data.resultItems;
      },

      async getAuthorTeam() {
        this.fetchingAuthorTeam = true;
        const { data } = await axios.get(`/api/courses/${this.courseId}/authorteamusers`);
        this.authorTeamUsers = data;
        this.fetchingAuthorTeam = false;
      },

      processSearch: _.debounce(function (e) {
        this.getUsers().then(() => {
          this.loadingAutocomplete = false;
        });
      }, 600),

      closeNewModal() {
        this.newDialog = false;
        this.newAuthorObject = null;
      },

      async saveNewAuthor() {
        this.savingNewAuthor = true;
        await axios.post(`/api/courses/${this.courseId}/authorteamusers`, this.newAuthorObject);
        this.newDialog = false;
        this.newAuthorObject = null;
        await this.getAuthorTeam();
        this.savingNewAuthor = false;
      },

      async deleteAuthor(item) {
        const result = confirm('Are you sure you want to delete this author team user?'); // eslint-disable-line
        if (result) {
          this.authorTeamUsers.filter(i => i.id !== item.id);
          await axios.delete(`/api/courses/${this.courseId}/authorteamusers/${item.id}`);
          await this.getAuthorTeam();
        }
      },
    },
  };
</script>